import { faHome, faUser } from '@fortawesome/pro-regular-svg-icons';
import { Button, Select } from '@nazka/nazka.mapframe.components';
import { useNavigate, useParams } from 'react-router-dom';

import { CASE_STUDIES } from '@App/pages/Home/CaseStudies/case-studies.constants';

import './navbar.css';

function Navbar({ breadcrumbs = [] }) {
  const navigate = useNavigate();

  const { caseStudyId, sectionId } = useParams();

  return (
    <div className="navbar">
      <Button
        icon={faHome}
        layout="outlined"
        color="var(--color-common-grey-dark)"
        className="navbar__home"
        onClick={() => navigate('/')}
      />
      <div className="navbar__breadcrumbs">
        <Select
          className="navbar__breadcrumbs__select"
          options={CASE_STUDIES}
          value={caseStudyId}
          onInputChange={({ id }) => navigate(`/${id}/context`)}
        />
        {breadcrumbs.map(crumb => (
          <Button
            key={crumb.id}
            layout="ghost"
            icon={crumb.icon}
            className={`navbar__breadcrumbs__button${sectionId === crumb.id ? ' navbar__breadcrumbs__button--active' : ''}`}
            onClick={() => navigate(`/${caseStudyId}/${crumb.id}`)}
          >
            {crumb.label}
          </Button>
        ))}
      </div>
      <div className="navbar__actions">
        <Button
          layout="ghost"
          hover={false}
          className="navbar__actions__button"
        >
          Contact
        </Button>
        <Button
          layout="ghost"
          hover={false}
          className="navbar__actions__button"
          icon={faUser}
        >
          Login / Sign up
        </Button>
      </div>
    </div>
  );
}

export default Navbar;
